import { getAllCourses as getBaseCourses } from '@/data/courses';
import { SQL_COURSES, SQL_ADVANCED_PHASE_COURSES } from '@/data/sql';
import { SQL_PHASE1_COURSES } from '@/data/sql/phase1';
import { PYTHON_COURSES } from '@/data/pythonCourseData';
import { AI_COURSES } from '@/data/ai';
import { ML_COURSES } from '@/data/ml';
import { JAVA_COURSES } from '@/data/java';
import { DOTNET_COURSES } from '@/data/dotnet';
import { CSHARP_COURSES } from '@/data/csharp';
import { AZURE_COURSES } from '@/data/azure';
import { AWS_COURSES } from '@/data/aws';
import { ENTERPRISE_TRAINING_COURSES } from '@/data/enterprise-training';
import { PROFESSIONAL_DEVELOPMENT_COURSES } from '@/data/professional-development';
import { JAVASCRIPT_COURSES } from '@/data/javascript';
import { DEVOPS_COURSES } from '@/data/devops';
import { BACKEND_COURSES } from '@/data/backend';
import { SECURITY_COURSES } from '@/data/security';
import { MOBILE_COURSES } from '@/data/mobile';
import { GCP_COURSES } from '@/data/gcp';
import { DATA_SCIENCE_COURSES } from '@/data/data-science';
import { DATABASE_COURSES } from '@/data/database';
import { BLOCKCHAIN_COURSES } from '@/data/blockchain';
import { RPA_COURSES } from '@/data/rpa';
import { GRAPHICS_COURSES } from '@/data/graphics';
import { DATASCIENCE_COURSES } from '@/data/datascience';
import { DATAENGINEERING_COURSES } from '@/data/dataengineering';
import { ETL_COURSES } from '@/data/etl';
import { APPSEC_COURSES } from '@/data/appsec';
import { INFRASTRUCTURE_COURSES } from '@/data/infrastructure';
import { FRONTEND_ADVANCED_COURSES } from '@/data/frontend-advanced';
import { TESTING_MODERN_COURSES } from '@/data/testing-modern';
import { SELENIUM_COURSES } from '@/data/testing';
import { WEB3_DEVELOPMENT_COURSES } from '@/data/web3-development';
import { SERVERLESS_EDGE_COURSES } from '@/data/serverless-edge';
import { POWERBI_COURSES } from '@/data/powerbi';
import { TABLEAU_COURSES } from '@/data/tableau';
import { UNITY_GAME_DEVELOPMENT, UNREAL_GAME_DEVELOPMENT, AR_VR_DEVELOPMENT, DESKTOP_APPLICATION_DEVELOPMENT } from '@/data/game-development';
import { UI_UX_COURSES } from '@/data/ui-ux-design';
import { GRAPHICS_PROGRAMMING_COURSES } from '@/data/graphics-programming';
import { RUST_COURSES } from '@/data/rust';
import { MODERN_FRONTEND_COURSES } from '@/data/modern-frontend';
import { KUBERNETES_MASTERY_COURSES } from '@/data/kubernetes-mastery';
import { EDGE_COMPUTING_COURSES } from '@/data/edge-computing';
import { CROSS_PLATFORM_COURSES } from '@/data/cross-platform';
import { GREEN_TECH_COURSES } from '@/data/green-tech';
import { NO_CODE_COURSES } from '@/data/no-code';
import { ADVANCED_API_COURSES } from '@/data/advanced-api';
import { AUTOMATION_COURSES } from '@/data/automation';
import { SPECIALIZED_AI_COURSES } from '@/data/specialized-ai';

// Unified helper to aggregate all courses across all sources (220+ courses across 60+ categories)
export const getAllCoursesUnified = () => {
  const base = getBaseCourses();
  const extra = [
    ...SQL_COURSES,
    ...SQL_PHASE1_COURSES,
    ...SQL_ADVANCED_PHASE_COURSES,
    ...PYTHON_COURSES,
    ...AI_COURSES,
    ...ML_COURSES,
    ...JAVA_COURSES,
    ...DOTNET_COURSES,
    ...CSHARP_COURSES,
    ...AZURE_COURSES,
    ...AWS_COURSES,
    ...ENTERPRISE_TRAINING_COURSES,
    ...PROFESSIONAL_DEVELOPMENT_COURSES,
    ...JAVASCRIPT_COURSES,
    ...DEVOPS_COURSES,
    ...BACKEND_COURSES,
    ...SECURITY_COURSES,
    ...MOBILE_COURSES,
    ...GCP_COURSES,
    ...DATA_SCIENCE_COURSES,
    ...DATABASE_COURSES,
    ...BLOCKCHAIN_COURSES,
    ...RPA_COURSES,
    ...GRAPHICS_COURSES,
    ...DATASCIENCE_COURSES,
    ...DATAENGINEERING_COURSES,
    ...ETL_COURSES,
    ...APPSEC_COURSES,
    ...INFRASTRUCTURE_COURSES,
    ...FRONTEND_ADVANCED_COURSES,
    ...TESTING_MODERN_COURSES,
    ...SELENIUM_COURSES,
    ...WEB3_DEVELOPMENT_COURSES,
    ...SERVERLESS_EDGE_COURSES,
    ...POWERBI_COURSES,
    ...TABLEAU_COURSES,
    ...[UNITY_GAME_DEVELOPMENT],
    ...[UNREAL_GAME_DEVELOPMENT],
    ...[AR_VR_DEVELOPMENT],
    ...[DESKTOP_APPLICATION_DEVELOPMENT],
    ...UI_UX_COURSES,
    ...GRAPHICS_PROGRAMMING_COURSES,
    ...RUST_COURSES,
    ...MODERN_FRONTEND_COURSES,
    ...KUBERNETES_MASTERY_COURSES,
    ...EDGE_COMPUTING_COURSES,
    ...CROSS_PLATFORM_COURSES,
    ...GREEN_TECH_COURSES,
    ...NO_CODE_COURSES,
    ...ADVANCED_API_COURSES,
    ...AUTOMATION_COURSES,
    ...SPECIALIZED_AI_COURSES,
  ];

  // Merge and de-duplicate by id
  const byId = new Map<string, any>();
  [...base, ...extra].forEach((c: any) => {
    if (c && c.id && !byId.has(c.id)) byId.set(c.id, c);
  });

  return Array.from(byId.values());
};

export const getAllCourseIds = () => getAllCoursesUnified().map((c: any) => c.id);
